/**
 * Bug 7860 - decide se deve disparar o toast de "desconto familia aplicado".
 *
 * Dispara apenas na TRANSICAO: quando a contagem de poltronas de IDA cruza o limiar
 * (busSeatsCondition, ex.: leve 3) e o desconto familia esta habilitado, a vista e nao e remarcacao.
 * Espelha o mesmo gate do texto no bus-seat-selection.component
 * (familyDiscountAllowed && onlyMoneyOnPriceOption && !isRebooking), garantindo que o toast so
 * aparece nos cenarios em que o desconto de fato passa a valer.
 */
export function shouldNotifyFamilyApplied({
	prevGoingCount,
	currGoingCount,
	familyDiscountParameters,
	familyDiscountAllowed,
	onlyMoneyOnPriceOption,
	isRebooking,
}) {
	if (!familyDiscountAllowed || !onlyMoneyOnPriceOption || isRebooking) return false
	if (!familyDiscountParameters || !familyDiscountParameters.isActive) return false

	const condition = familyDiscountParameters.busSeatsCondition
	return prevGoingCount < condition && currGoingCount >= condition
}
